import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";
import { updateActivityName } from "../../Redux/activityRedux/activityAction";

export default function EditModal(props) {
  const [value, setValue] = useState(props.value);
  const [validate, setValidate] = useState(false);
  console.log(props)
  return (
    <Dialog open={props.isOpen} onClose={() => props.setEditOpen(false)}>
      <DialogTitle>Edit Subactivity Name</DialogTitle>
      <DialogContent>
        <TextField
          defaultValue={props.value}
          onChange={e => setValue(e.target.value)}
          helperText={validate ? 'Nothing to change' : ' '}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (value != "") {
              props.updateSubActivityNameUI(props.index, props.subIndex, value);
              props.setEditOpen(false);
            } else {
              setValidate(true)
            }
          }}
        >
          Save
        </Button>
        <Button color="secondary" onClick={() => props.setEditOpen(false)}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
